APPS.search.results = (function(){
    var show = function(term){
	    //loading animation
        APP.getView().showChildView('mainRegion',Backbone.Radio.channel('views').request('loading'))
		if(term){
		    $.when( Backbone.Radio.channel('entities').request('search',term) ).done(function(results){ 
			    APP.getView().showChildView('mainRegion', new pageView({results:results, term:term}) )
			})
			
			window.document.title = "WHRO Program Search Results";
            if(typeof ga != "undefined"){ ga('send','pageview',{ title:"WHRO Program Search Results" }) }
			if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': 'WHRO Program Search Results' }); }
            if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "WHRO Program Search Results", '0', false, true); }
            
		}else{ //no search term, just give them the search field
			APP.getView().showChildView('mainRegion', new pageView({}) )
			
			window.document.title = "WHRO Program Search";
            if(typeof ga != "undefined"){ 
	            ga('set','title',"WHRO Program Search");
				ga('send','pageview');
			}
			if(typeof gtag != "undefined"){
				gtag('set', { 'page_title': 'WHRO Program Search' });
				gtag('event', 'page_view');
			}
            if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "WHRO Program Search", '0', false, true); }
		}
		
	}
	
	
	
	
	
	
	
	
	
	
	//single show
        var resultView = Marionette.View.extend({
             tagName:"div"
            ,className:"col-6 col-md-4 col-lg-3 pt4 border-b"
            ,template:_.template('<div class="row program"><div class="col-12"><a href="<%-url%>"><img style="max-width:100%" src="<%=images%>"/><h3 class="m0 mt1 font-normal"><%=title%></h3></a><% if(desc_short){%><p class="font-light"><%=desc_short%></p><%}%></div></div>')
            ,templateContext:function(){
	            var img;
	            
	            if(this.model.attributes.type==="franchise"){
				    img = Backbone.Radio.channel('utilities').request('image-parse',{
			             json:this.model.attributes.images
			            ,desiredProfile:"franchise-poster2x3"
			        });
			    }
	            if(!img){
		            img = Backbone.Radio.channel('utilities').request('image-parse',{
			             json:this.model.attributes.images
			            ,desiredProfile:"show-poster2x3"
			        });
			    }
				if(!img){
		            img = Backbone.Radio.channel('utilities').request('image-parse',{
			             json:this.model.attributes.images
			            ,desiredProfile:"show-banner"
			        });
	            }
	            if(!img){ img = "/assets/imgs/tvplaceholder_Poster_480x720.jpg"; }
	           
	            //PBS sends huge images, but allows you to set whatever crop you want
		        if(img && img.indexOf("image.pbs.org") !== -1){
			        img += ".crop.300x450.jpg";
		        }
                
                return {
                     images: img
                    ,url: ((this.model.attributes.type==="franchise")?"/franchise/":"/program/")+this.model.attributes.slug
                }
            }
            ,events:{
                "click a": function(e){
                    e.preventDefault();
                    if(this.model.attributes.type==="franchise"){
	                    Backbone.Radio.channel('franchise').request('show',this.model.attributes.slug)
                    }else{
	                    Backbone.Radio.channel('shows').request('show',this.model.attributes.slug)
	                }
                }
            }
        })
        var collectionView = Mn.CollectionView.extend({
             tagName: 'div'
            ,className:"row border-b"
            ,childView: resultView
        });
    
    
    //single episode
        var episodeView = Marionette.View.extend({
             tagName:"div"
            ,className:"col-12 pt4"
            ,template:_.template('<div class="program"><a href="<%-url%>"><h3 class="h2 m0 mt1"><%=title%></h3></a><% if(show_title){%><p class="font-size1 mb0"><%=show_title%></p><%}%><% if(desc){%><p class="font-light mb0"><%=desc%></p><%}%><div style="font-size:.90rem;"><% if(foundArtists.length){ %><p class="font-light mb0"><em>Matched Artists: <%-foundArtists.join(", ") %></em></p><% } %><% if(foundSongs.length){ %><p class="font-light mb0"><em>Matched Songs: <%-foundSongs.join(", ") %></em></p><% } %><% if(foundComposers.length){ %><p class="font-light mb0"><em>Matched Composers: <%-foundComposers.join(", ") %></em></p><% } %><% if(foundAlbums.length){ %><p class="font-light mb0"><em>Matched Albums: <%-foundAlbums.join(", ") %></em></p><% } %></div></div>')
            
            ,templateContext:function(){
	            var term = this.model.collection.term;
	            var foundArtists = [];
	            var foundSongs = [];
	            var foundComposers = [];
	            var foundAlbums = [];
	            if( Array.isArray(this.model.attributes.playlist_artist) ){
		            foundArtists = this.model.attributes.playlist_artist.filter(function(el){
			            return el.toLowerCase().indexOf(term.toLowerCase()) > -1;
					});	
				}
				if( Array.isArray(this.model.attributes.playlist_song) ){
		            foundSongs = this.model.attributes.playlist_song.filter(function(el){
			            return el.toLowerCase().indexOf(term.toLowerCase()) > -1;
					});
				}
				if( Array.isArray(this.model.attributes.playlist_composer) ){
		            foundComposers = this.model.attributes.playlist_composer.filter(function(el){
			            return el.toLowerCase().indexOf(term.toLowerCase()) > -1;
					});
				}
				if( Array.isArray(this.model.attributes.playlist_album) ){
		            foundAlbums = this.model.attributes.playlist_album.filter(function(el){
			            return el.toLowerCase().indexOf(term.toLowerCase()) > -1;
					});	
				}
				var desc = (this.model.attributes.desc_short)?this.model.attributes.desc_short:this.model.attributes.desc_long;
	            if(!desc && this.model.attributes.desc_long){
		            desc = this.model.attributes.desc_long;
		            if (desc.length > 400) { //we typically only have long_desc for podcasts, and they can be really long
				        var subString = desc.substr(0, 400-1);
						desc = subString.substr(0, subString.lastIndexOf(' ')) + "&hellip;";
					} 
	            }
	            
	            return {
                     url: ((this.model.attributes.type==="franchise")?"/franchise/":"/program/")+this.model.attributes.slug
                    ,desc:desc
                    ,foundArtists:_.uniq(foundArtists)
                    ,foundSongs:_.uniq(foundSongs)
                    ,foundComposers:_.uniq(foundComposers)
                    ,foundAlbums:_.uniq(foundAlbums)
                }
            }
        })
        var collectionEpisodeView = Mn.CollectionView.extend({
             tagName: 'div'
            ,className:"row"
            ,childView: episodeView
        });   
	
	
	// THE PAGE
        var pageView = Marionette.View.extend({
             template:"#tmpl-search-results"
            ,className:"page_search_results mt8"
            ,regions:{
                resultsShows:{
                    el: '#showRowsContainer'
                }
                ,resultsEpisodes:{
                    el: '#episodeRowsContainer'
                }
            }
            ,templateContext:function(){
	            return {
		        	pageTitle : (this.options.term)?'Results for &ldquo;'+this.options.term+'&rdquo;':"Program Search"
	        	}  
	        }
            ,events:{
	             "click .searchHeader button":"search"
	            ,"keypress .searchHeader input":function(e){
					if(e.which===13){ this.$el.find('button').trigger('click'); }
				}
				,"click #btnProgramResults":function(e){
					this.$el.find("#showRowsContainer>.row>div").show()
					$(e.currentTarget).hide()
				}
				,"click #btnEpisodeResults":function(e){
					this.$el.find("#episodeRowsContainer>.row>div").show()
					$(e.currentTarget).hide()
				}
            }
            ,onRender: function() {
	            if(this.options.results){
		        	if(this.options.results.shows.length){
			        	this.showChildView('resultsShows', new collectionView({
		                    collection: this.options.results.shows
		                }));
		                //3 because that is the least number of results we show (on iPads)
		                //	This does mean that exact 4 results will incorrectly show the button on desktop/mobile
		                if(this.options.results.shows.length <=3){ 
			                this.$el.find('#btnProgramResults').hide();
		                }
			        }else{
				    	this.$el.find('#showRowsContainer').html('No show results found.')
				    	this.$el.find('#btnProgramResults').hide();
			        }
			        
			        if(this.options.results.episodes.length){
			        	this.showChildView('resultsEpisodes', new collectionEpisodeView({
		                    collection: this.options.results.episodes
		                }));
		                if(this.options.results.episodes.length <=4){ 
			                this.$el.find('#btnEpisodeResults').hide();
		                }
			        }else{
				    	this.$el.find('#episodeRowsContainer').html('No episode results found.');
				    	this.$el.find('#btnEpisodeResults').hide();    
			        }
	            }else{ //there should always be a results set, even if it is empty. This is just a fallback if something fails.
		            this.$el.find('#showRowsContainer').html('No show results found.');
		            this.$el.find('#btnProgramResults').hide();
		            this.$el.find('#episodeRowsContainer').html('No episode results found.');
		            this.$el.find('#btnEpisodeResults').hide();
	            }
            }
            ,search: function(e){
	            var term = this.$el.find('input').val().trim().replace(/[^\w\s-]/gi,'');
	            if(term){
	            	window.location.href="/search/"+term;
	            }
            }
        })
	    
	    
	return {
		show:show
	}
})();